import urlServices from "../../environments/API"
import requestOptions from '../services/RequestOptions'
import Logs from '../../components/General/LogDetail'
import GeneralMapper from '../models/General_Mapper'

const urlSeguridades = urlServices.seguridad
const urlSeguridadBI = urlServices.configuracion

const loginMapper = async (data) => {
    let responseMapper = []
    responseMapper = {
        code: data.code ?? '500',
        success: data.success ?? 'false',
        message: global.LOGIN_MESSAGE + data.data.nombreUsuario ?? global.ERROR_MESSAGE,
        variant: data.success ? global.VARIANT_SUCCESS : global.VARIANT_ERROR,
        data: data.data
    }

    let responseMapperError = []
    responseMapperError = {
        code:  '400',
        success:  'false',
        message: 'El usuario ' +  data.data.nombreUsuario +' no tiene permisos para acceder al portal, por favor comunicarse con mesa de ayuda' ,
        variant:  global.VARIANT_WARNING,
        data: 'ERROR'
    }

    localStorage.setItem('token', data.data.idToken)
    localStorage.setItem('data', JSON.stringify(data.data))
    localStorage.setItem('userName', data.data.nombreUsuario)
    localStorage.setItem('secuenciaUsuario', data.data.secuenciaUsuario)
    localStorage.setItem('refreshToken', data.data.refreshToken)
    localStorage.setItem('codigoUsuario', data.data.codigoUsuario)

    const token = `Bearer ${data.data.idToken}`
    const options = requestOptions.optionsModuleMenu('GET', token, '')
    //const respModulo = await fetch(urlSeguridades + '/usuarios/' + data.data.secuenciaUsuario + global.MODULE_ACCESS + '?tipoSucursal=CMV', options)
    //const dataModulo = await respModulo.json()
    //const respSucursal = await fetch(urlSeguridades + '/usuarios/' + data.data.secuenciaUsuario + global.MODULE_SUCURSAL + '?tipoSucursal=TODOS', options)
    //const dataSucursal = await respSucursal.json()
    if (true) {
       // const filter = '?codigoModulo=' + global.MODULO_CODE + '&codigoSucursal=' + dataSucursal.data[0]['codigoSucursal']

        const filter2 = '?secuenciaUsuario='+data.data.secuenciaUsuario+'&opcionesMenu=S'

        //const respOptionAccess = await fetch(urlSeguridades + '/usuarios/' + data.data.secuenciaUsuario + global.MODULE_ACCESS_OPTION + filter, options)
        const respOptionAccess = await fetch(urlSeguridadBI  + global.GET_CONFIG_USER + filter2, options)

        const dataOptionAccess = await respOptionAccess.json()
    let responseD;
            // ✅ Validación de usuarioMenu (dataOptionAccess.data)


    console.log("---_> --" + dataOptionAccess);

    if (dataOptionAccess.data.length === 0) {
      console.error('El usuario no tiene opciones de menú');
      localStorage.clear();
      responseD = GeneralMapper.warningMapper(responseMapperError);
        setTimeout(() => {
            window.location.href = '/';
        }, 10000);
      return responseD;
    }


    if (!dataOptionAccess.data) {
      console.error('usuarioMenu es undefined o null');
      localStorage.clear();
      responseD = GeneralMapper.warningMapper(responseMapperError);
        setTimeout(() => {
            window.location.href = '/';
        }, 6000);
      return responseD;
    }

         const usuarioMenuOrdenado = dataOptionAccess.data.sort((a, b) => a.codigoOpcion - b.codigoOpcion);

        localStorage.setItem('usuarioMenu', JSON.stringify(usuarioMenuOrdenado));
        
        const respAppMenu = await fetch("https://api.phantomx.com.ec/seguridad/v1/aplicaciones/6/opciones_menu", options)
        const dataAppMenu = await respAppMenu.json()
        if (dataAppMenu.success && dataAppMenu.code === 200) {
            localStorage.setItem('appMenu', JSON.stringify(dataAppMenu.data[0]["opcionesMenu"]))
        } else {
            localStorage.setItem('appMenu', JSON.stringify([]))
        }
        Logs.logDetail(data.data.secuenciaUsuario, "Login", "Inicio de sesión", "login", data.data.codigoUsuario)
    }

    return responseMapper
}

const loginMapperUserEx = async (data) => {
    let responseMapper = []
    responseMapper = {
        code: data.code ?? '500',
        success: data.success ?? 'false',
        message: global.LOGIN_MESSAGE + data.data.nombreUsuario ?? global.ERROR_MESSAGE,
        variant: data.success ? global.VARIANT_SUCCESS : global.VARIANT_ERROR,
        data: data.data
    }

    let responseMapperError = []
    responseMapperError = {
        code:  '400',
        success:  'false',
        message: 'El usuario ' +  data.data.nombreUsuario +' no tiene permisos para acceder al portal, por favor comunicarse con mesa de ayuda' ,
        variant:  global.VARIANT_WARNING,
        data: 'ERROR'
    }

    localStorage.setItem('token', data.data.idToken)
    localStorage.setItem('data', JSON.stringify(data.data))
    localStorage.setItem('userName', data.data.nombreUsuario)
    localStorage.setItem('secuenciaUsuario', data.data.secuenciaUsuario)
    localStorage.setItem('refreshToken', data.data.refreshToken)
    localStorage.setItem('codigoUsuario', data.data.codigoUsuario)

    localStorage.setItem('appMenu', JSON.stringify(data.data.listOpcionesMenu));
    localStorage.setItem('usuarioMenu', JSON.stringify(data.data.listOpcionesMenu));

    const token = `Bearer ${data.data.idToken}`
    const options = requestOptions.optionsModuleMenu('GET', token, '')
    const respModulo = await fetch(urlSeguridades + '/usuarios/' + data.data.secuenciaUsuario + global.MODULE_ACCESS + '?tipoSucursal=CMV', options)
    const dataModulo = await respModulo.json()
    const respSucursal = await fetch(urlSeguridades + '/usuarios/' + data.data.secuenciaUsuario + global.MODULE_SUCURSAL + '?tipoSucursal=TODOS', options)
    const dataSucursal = await respSucursal.json()
    if ((dataModulo.success && dataModulo.code === 200) && (dataSucursal.success && dataSucursal.code === 200)) {
        const filter = '?codigoModulo=' + global.MODULO_CODE + '&codigoSucursal=' + dataSucursal.data[0]['codigoSucursal']
        const respOptionAccess = await fetch(urlSeguridades + '/usuarios/' + data.data.secuenciaUsuario + global.MODULE_ACCESS_OPTION + filter, options)
        const dataOptionAccess = await respOptionAccess.json()
    let responseD;
            // ✅ Validación de usuarioMenu (dataOptionAccess.data)
    if (!dataOptionAccess.data) {
      console.error('usuarioMenu es undefined o null');
      localStorage.clear();
      responseD = GeneralMapper.warningMapper(responseMapperError);
        setTimeout(() => {
            window.location.href = '/';
        }, 6000);
      return responseD;
    }

        localStorage.setItem('usuarioMenu', JSON.stringify(dataOptionAccess.data))

        const respAppMenu = await fetch("https://api.phantomx.com.ec/seguridad/v1/aplicaciones/6/opciones_menu", options)
        const dataAppMenu = await respAppMenu.json()
        if (dataAppMenu.success && dataAppMenu.code === 200) {
            localStorage.setItem('appMenu', JSON.stringify(dataAppMenu.data[0]["opcionesMenu"]))
        } else {
            localStorage.setItem('appMenu', JSON.stringify([]))
        }
        Logs.logDetail(data.data.secuenciaUsuario, "Login", "Inicio de sesión", "login", data.data.codigoUsuario)
    }

    return responseMapper
}


const AuthMapper = {
    loginMapper,
    loginMapperUserEx
}

export default AuthMapper
